import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { getCurrentPathForAuthRedirect } from './authRedirect';

// Add an optional requireAuth prop with a default value of true
const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // If requireAuth is true and no currentUser is found, redirect to the login page
  if (requireAuth && (!currentUser || currentUser.is_anonymous)) {
    return (
      <Navigate
        to={currentUser?.is_anonymous ? "/signup" : "/login"}
        replace
        state={{ from: getCurrentPathForAuthRedirect(location) }}
      />
    );
  }

  // If requireAuth is false or currentUser exists, render the children components
  return children;
};

export default ProtectedRoute;
